"use client";
import { Center, CenterProps } from "@chakra-ui/react";
import { LoadingDots } from "./loading-dots";

export const LoadingArea = (props: CenterProps) => (
  <Center color="blue.500" {...props}>
    <LoadingDots color="currentColor" />
  </Center>
);
